import { render, staticRenderFns } from "./consider_transfer_master.vue?vue&type=template&id=34fa60bc"
import script from "./consider_transfer_master.vue?vue&type=script&lang=js"
export * from "./consider_transfer_master.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports